var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27147",
    "data-name": "Group 27147",
    transform: "translate(-31 -133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M18,18V7.132l-8-4.8-8,4.8V18H6V15.25a4,4,0,0,1,8,0V18Zm-6,2V15.25a2,2,0,0,0-4,0V20H2a2,2,0,0,1-2-2V7.132A2,2,0,0,1,.971,5.417l8-4.8a2,2,0,0,1,2.058,0l8,4.8A2,2,0,0,1,20,7.132V18a2,2,0,0,1-2,2Z",
    transform: "translate(37 138.668)",
    fill: "#84848a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemState);
export default __webpack_public_path__ + "static/media/System_State.2004a251.svg";
export { ForwardRef as ReactComponent };